// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stm-shell {
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  background: #0f172a;
  border: 1px solid rgba(148, 163, 184, 0.24);
  border-radius: 8px;
  overflow: hidden;
  color: #e2e8f0;
}

.stm-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  background: rgba(15, 23, 42, 0.96);
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
}

.stm-toolbar h2 {
  margin: 0;
  font-size: 1rem;
  line-height: 1.2;
  font-weight: 750;
  color: #f8fafc;
}

.stm-toolbar span {
  display: block;
  margin-top: 3px;
  font-size: 0.74rem;
  color: #94a3b8;
}

.stm-zoom {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.stm-zoom button {
  width: 30px;
  height: 30px;
  border: 1px solid rgba(148, 163, 184, 0.3);
  border-radius: 6px;
  background: rgba(30, 41, 59, 0.84);
  color: #e2e8f0;
  font-size: 1.05rem;
  font-weight: 750;
  cursor: pointer;
}

.stm-zoom button:hover {
  border-color: rgba(96, 165, 250, 0.65);
  color: #bfdbfe;
}

.stm-zoom strong {
  min-width: 44px;
  text-align: center;
  font-size: 0.75rem;
  color: #cbd5e1;
  font-variant-numeric: tabular-nums;
}

.stm-content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 272px;
  min-height: 0;
}

.stm-viewport {
  min-width: 0;
  overflow: auto;
  background:
    linear-gradient(rgba(148, 163, 184, 0.055) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.055) 1px, transparent 1px),
    #020617;
  background-size: 36px 36px;
}

.stm-svg {
  display: block;
}

.stm-edges path {
  stroke: rgba(148, 163, 184, 0.5);
  stroke-width: 1.6;
}

.stm-node {
  cursor: pointer;
  outline: none;
}

.stm-node circle,
.stm-node path {
  transition: stroke 140ms ease, fill 140ms ease, opacity 140ms ease;
}

.stm-node:hover circle:first-child,
.stm-node--selected circle:first-child {
  opacity: 1;
}

.stm-node--locked {
  cursor: default;
}

.stm-node--locked-by-level,
.stm-node--locked-by-foreign-keystone {
  cursor: default;
}

.stm-node--locked-by-level {
  opacity: 0.72;
}

.stm-node--unlockable-now {
  filter: drop-shadow(0 0 10px rgba(250, 204, 21, 0.38));
}

.stm-node__label {
  fill: #e2e8f0;
  font-size: 10px;
  font-weight: 650;
  pointer-events: none;
}

.stm-node--locked-by-level .stm-node__label,
.stm-node--locked-by-foreign-keystone .stm-node__label {
  fill: #cbd5e1;
}

.stm-node__handler {
  font-size: 8px;
  font-weight: 750;
  text-transform: uppercase;
  pointer-events: none;
}

.stm-node__pulse {
  opacity: 0.72;
  transform-origin: center;
  animation: stm-node-pulse 1.45s ease-out infinite;
}

.stm-node__progress rect:first-child {
  fill: rgba(148, 163, 184, 0.22);
}

.stm-node__progress-fill {
  fill: #22d3ee;
}

.stm-node__progress text {
  fill: #93c5fd;
  font-size: 8px;
  font-weight: 750;
  pointer-events: none;
}

.stm-node__lock {
  opacity: 0.94;
}

.stm-detail {
  min-width: 0;
  padding: 16px;
  border-left: 1px solid rgba(148, 163, 184, 0.18);
  background: rgba(15, 23, 42, 0.9);
}

.stm-detail__status {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  border-radius: 999px;
  color: #cbd5e1;
  font-size: 0.68rem;
  font-weight: 750;
  text-transform: uppercase;
}

.stm-detail h3 {
  margin: 12px 0 6px;
  font-size: 1rem;
  color: #f8fafc;
}

.stm-detail p {
  margin: 0 0 14px;
  color: #94a3b8;
  font-size: 0.82rem;
  line-height: 1.45;
}

.stm-detail__progress {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin: 0 0 14px;
  padding: 10px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 8px;
  background: rgba(2, 6, 23, 0.34);
}

.stm-detail__progress div:first-child {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: #94a3b8;
  font-size: 0.7rem;
  font-weight: 750;
}

.stm-detail__progress strong {
  color: #e2e8f0;
  font-variant-numeric: tabular-nums;
}

.stm-detail__progress-track {
  height: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.16);
}

.stm-detail__progress-track span {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background: #22d3ee;
  transform-origin: left center;
}

.stm-detail__prereqs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 14px;
}

.stm-detail__prereqs span {
  width: 100%;
  color: #64748b;
  font-size: 0.68rem;
  font-weight: 750;
  text-transform: uppercase;
}

.stm-detail__prereqs code {
  padding: 3px 6px;
  border-radius: 5px;
  background: rgba(15, 23, 42, 0.92);
  border: 1px solid rgba(148, 163, 184, 0.22);
  color: #cbd5e1;
  font-size: 0.72rem;
}

.stm-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px dashed rgba(148, 163, 184, 0.34);
  border-radius: 8px;
  background: #0f172a;
  color: #94a3b8;
}

.stm-empty__title {
  font-weight: 750;
  color: #e2e8f0;
}

.stm-empty__sub {
  font-size: 0.82rem;
}

.stm-card-unlock {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 74px;
  padding: 12px;
  overflow: hidden;
  border: 1px solid rgba(251, 191, 36, 0.34);
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(251, 191, 36, 0.18), rgba(15, 23, 42, 0.94) 58%);
  box-shadow: 0 12px 30px rgba(251, 191, 36, 0.12);
  animation: stm-card-pop 220ms ease-out;
}

.stm-card-unlock__shine {
  position: absolute;
  inset: -30% auto -30% -40%;
  width: 40%;
  transform: rotate(18deg);
  background: rgba(255, 255, 255, 0.18);
  animation: stm-shine 1.8s ease-in-out infinite;
}

.stm-card-unlock__icon {
  position: relative;
  z-index: 1;
  display: grid;
  place-items: center;
  width: 42px;
  height: 52px;
  border: 1px solid rgba(251, 191, 36, 0.42);
  border-radius: 6px;
  color: #fbbf24;
  background: rgba(15, 23, 42, 0.76);
}

.stm-card-unlock__icon svg {
  width: 25px;
  height: 25px;
}

.stm-card-unlock__kicker {
  position: relative;
  z-index: 1;
  color: #facc15;
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
}

.stm-card-unlock__name {
  position: relative;
  z-index: 1;
  color: #f8fafc;
  font-size: 0.93rem;
  font-weight: 750;
}

.stm-passive-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  min-height: 32px;
  padding: 6px 10px;
  border: 1px solid rgba(52, 211, 153, 0.28);
  border-radius: 999px;
  background: rgba(6, 78, 59, 0.26);
  color: #d1fae5;
}

.stm-passive-badge__dot {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #34d399;
  box-shadow: 0 0 10px rgba(52, 211, 153, 0.68);
}

.stm-passive-badge__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.78rem;
  font-weight: 750;
}

.stm-passive-badge__value {
  color: #6ee7b7;
  font-size: 0.72rem;
  font-weight: 700;
}

.stm-xp-floater {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 92px;
  min-height: 52px;
  padding: 7px 12px;
  border-radius: 999px;
  background: rgba(14, 165, 233, 0.13);
  border: 1px solid rgba(96, 165, 250, 0.35);
  color: #bfdbfe;
  animation: stm-xp-rise 1.35s ease both;
}

.stm-xp-floater__amount {
  font-size: 1rem;
  font-weight: 850;
}

.stm-xp-floater__tags {
  max-width: 132px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #93c5fd;
  font-size: 0.68rem;
}

.stm-keystone-marker {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 160px;
  padding: 10px 12px;
  border: 1px solid var(--stm-keystone-accent);
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.82);
}

.stm-keystone-marker__ring {
  height: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.18);
}

.stm-keystone-marker__ring span {
  display: block;
  width: 100%;
  height: 100%;
  transform-origin: left center;
  background: var(--stm-keystone-accent);
  border-radius: inherit;
}

.stm-keystone-marker__copy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: #e2e8f0;
  font-size: 0.78rem;
}

.stm-keystone-marker__copy strong {
  color: var(--stm-keystone-accent);
  font-size: 0.8rem;
}

@keyframes stm-card-pop {
  from { opacity: 0; transform: translateY(6px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes stm-shine {
  0% { left: -42%; }
  52%, 100% { left: 118%; }
}

@keyframes stm-node-pulse {
  0% { opacity: 0.7; transform: scale(0.92); }
  72%, 100% { opacity: 0; transform: scale(1.34); }
}

@keyframes stm-xp-rise {
  0% { opacity: 0; transform: translateY(8px) scale(0.94); }
  18% { opacity: 1; transform: translateY(0) scale(1.04); }
  100% { opacity: 0; transform: translateY(-42px) scale(0.96); }
}

@media (max-width: 820px) {
  .stm-content {
    grid-template-columns: 1fr;
  }

  .stm-detail {
    border-left: 0;
    border-top: 1px solid rgba(148, 163, 184, 0.18);
  }
}

@media (prefers-reduced-motion: reduce) {
  .stm-card-unlock,
  .stm-card-unlock__shine,
  .stm-node__pulse,
  .stm-xp-floater {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SkillTreeMap/SkillTreeMap.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd;;;WAGS;EACT,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,kEAAkE;AACpE;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,yFAAyF;EACzF,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,wBAAwB;EACxB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,YAAY,UAAU,EAAE;AAC1B;;AAEA;EACE,KAAK,YAAY,EAAE,sBAAsB,EAAE;EAC3C,YAAY,UAAU,EAAE,sBAAsB,EAAE;AAClD;;AAEA;EACE,KAAK,UAAU,EAAE,sCAAsC,EAAE;EACzD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,OAAO,UAAU,EAAE,wCAAwC,EAAE;AAC/D;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,+CAA+C;EACjD;AACF;;AAEA;EACE;;;;IAIE,eAAe;EACjB;AACF","sourcesContent":[".stm-shell {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  width: 100%;\n  background: #0f172a;\n  border: 1px solid rgba(148, 163, 184, 0.24);\n  border-radius: 8px;\n  overflow: hidden;\n  color: #e2e8f0;\n}\n\n.stm-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 16px;\n  background: rgba(15, 23, 42, 0.96);\n  border-bottom: 1px solid rgba(148, 163, 184, 0.18);\n}\n\n.stm-toolbar h2 {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.2;\n  font-weight: 750;\n  color: #f8fafc;\n}\n\n.stm-toolbar span {\n  display: block;\n  margin-top: 3px;\n  font-size: 0.74rem;\n  color: #94a3b8;\n}\n\n.stm-zoom {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.stm-zoom button {\n  width: 30px;\n  height: 30px;\n  border: 1px solid rgba(148, 163, 184, 0.3);\n  border-radius: 6px;\n  background: rgba(30, 41, 59, 0.84);\n  color: #e2e8f0;\n  font-size: 1.05rem;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.stm-zoom button:hover {\n  border-color: rgba(96, 165, 250, 0.65);\n  color: #bfdbfe;\n}\n\n.stm-zoom strong {\n  min-width: 44px;\n  text-align: center;\n  font-size: 0.75rem;\n  color: #cbd5e1;\n  font-variant-numeric: tabular-nums;\n}\n\n.stm-content {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 272px;\n  min-height: 0;\n}\n\n.stm-viewport {\n  min-width: 0;\n  overflow: auto;\n  background:\n    linear-gradient(rgba(148, 163, 184, 0.055) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(148, 163, 184, 0.055) 1px, transparent 1px),\n    #020617;\n  background-size: 36px 36px;\n}\n\n.stm-svg {\n  display: block;\n}\n\n.stm-edges path {\n  stroke: rgba(148, 163, 184, 0.5);\n  stroke-width: 1.6;\n}\n\n.stm-node {\n  cursor: pointer;\n  outline: none;\n}\n\n.stm-node circle,\n.stm-node path {\n  transition: stroke 140ms ease, fill 140ms ease, opacity 140ms ease;\n}\n\n.stm-node:hover circle:first-child,\n.stm-node--selected circle:first-child {\n  opacity: 1;\n}\n\n.stm-node--locked {\n  cursor: default;\n}\n\n.stm-node--locked-by-level,\n.stm-node--locked-by-foreign-keystone {\n  cursor: default;\n}\n\n.stm-node--locked-by-level {\n  opacity: 0.72;\n}\n\n.stm-node--unlockable-now {\n  filter: drop-shadow(0 0 10px rgba(250, 204, 21, 0.38));\n}\n\n.stm-node__label {\n  fill: #e2e8f0;\n  font-size: 10px;\n  font-weight: 650;\n  pointer-events: none;\n}\n\n.stm-node--locked-by-level .stm-node__label,\n.stm-node--locked-by-foreign-keystone .stm-node__label {\n  fill: #cbd5e1;\n}\n\n.stm-node__handler {\n  font-size: 8px;\n  font-weight: 750;\n  text-transform: uppercase;\n  pointer-events: none;\n}\n\n.stm-node__pulse {\n  opacity: 0.72;\n  transform-origin: center;\n  animation: stm-node-pulse 1.45s ease-out infinite;\n}\n\n.stm-node__progress rect:first-child {\n  fill: rgba(148, 163, 184, 0.22);\n}\n\n.stm-node__progress-fill {\n  fill: #22d3ee;\n}\n\n.stm-node__progress text {\n  fill: #93c5fd;\n  font-size: 8px;\n  font-weight: 750;\n  pointer-events: none;\n}\n\n.stm-node__lock {\n  opacity: 0.94;\n}\n\n.stm-detail {\n  min-width: 0;\n  padding: 16px;\n  border-left: 1px solid rgba(148, 163, 184, 0.18);\n  background: rgba(15, 23, 42, 0.9);\n}\n\n.stm-detail__status {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  border-radius: 999px;\n  color: #cbd5e1;\n  font-size: 0.68rem;\n  font-weight: 750;\n  text-transform: uppercase;\n}\n\n.stm-detail h3 {\n  margin: 12px 0 6px;\n  font-size: 1rem;\n  color: #f8fafc;\n}\n\n.stm-detail p {\n  margin: 0 0 14px;\n  color: #94a3b8;\n  font-size: 0.82rem;\n  line-height: 1.45;\n}\n\n.stm-detail__progress {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  margin: 0 0 14px;\n  padding: 10px;\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  border-radius: 8px;\n  background: rgba(2, 6, 23, 0.34);\n}\n\n.stm-detail__progress div:first-child {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  color: #94a3b8;\n  font-size: 0.7rem;\n  font-weight: 750;\n}\n\n.stm-detail__progress strong {\n  color: #e2e8f0;\n  font-variant-numeric: tabular-nums;\n}\n\n.stm-detail__progress-track {\n  height: 7px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.16);\n}\n\n.stm-detail__progress-track span {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n  background: #22d3ee;\n  transform-origin: left center;\n}\n\n.stm-detail__prereqs {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-top: 14px;\n}\n\n.stm-detail__prereqs span {\n  width: 100%;\n  color: #64748b;\n  font-size: 0.68rem;\n  font-weight: 750;\n  text-transform: uppercase;\n}\n\n.stm-detail__prereqs code {\n  padding: 3px 6px;\n  border-radius: 5px;\n  background: rgba(15, 23, 42, 0.92);\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  color: #cbd5e1;\n  font-size: 0.72rem;\n}\n\n.stm-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 1px dashed rgba(148, 163, 184, 0.34);\n  border-radius: 8px;\n  background: #0f172a;\n  color: #94a3b8;\n}\n\n.stm-empty__title {\n  font-weight: 750;\n  color: #e2e8f0;\n}\n\n.stm-empty__sub {\n  font-size: 0.82rem;\n}\n\n.stm-card-unlock {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 74px;\n  padding: 12px;\n  overflow: hidden;\n  border: 1px solid rgba(251, 191, 36, 0.34);\n  border-radius: 8px;\n  background: linear-gradient(135deg, rgba(251, 191, 36, 0.18), rgba(15, 23, 42, 0.94) 58%);\n  box-shadow: 0 12px 30px rgba(251, 191, 36, 0.12);\n  animation: stm-card-pop 220ms ease-out;\n}\n\n.stm-card-unlock__shine {\n  position: absolute;\n  inset: -30% auto -30% -40%;\n  width: 40%;\n  transform: rotate(18deg);\n  background: rgba(255, 255, 255, 0.18);\n  animation: stm-shine 1.8s ease-in-out infinite;\n}\n\n.stm-card-unlock__icon {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  place-items: center;\n  width: 42px;\n  height: 52px;\n  border: 1px solid rgba(251, 191, 36, 0.42);\n  border-radius: 6px;\n  color: #fbbf24;\n  background: rgba(15, 23, 42, 0.76);\n}\n\n.stm-card-unlock__icon svg {\n  width: 25px;\n  height: 25px;\n}\n\n.stm-card-unlock__kicker {\n  position: relative;\n  z-index: 1;\n  color: #facc15;\n  font-size: 0.68rem;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.stm-card-unlock__name {\n  position: relative;\n  z-index: 1;\n  color: #f8fafc;\n  font-size: 0.93rem;\n  font-weight: 750;\n}\n\n.stm-passive-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 100%;\n  min-height: 32px;\n  padding: 6px 10px;\n  border: 1px solid rgba(52, 211, 153, 0.28);\n  border-radius: 999px;\n  background: rgba(6, 78, 59, 0.26);\n  color: #d1fae5;\n}\n\n.stm-passive-badge__dot {\n  width: 8px;\n  height: 8px;\n  flex: 0 0 auto;\n  border-radius: 50%;\n  background: #34d399;\n  box-shadow: 0 0 10px rgba(52, 211, 153, 0.68);\n}\n\n.stm-passive-badge__label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.78rem;\n  font-weight: 750;\n}\n\n.stm-passive-badge__value {\n  color: #6ee7b7;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.stm-xp-floater {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 92px;\n  min-height: 52px;\n  padding: 7px 12px;\n  border-radius: 999px;\n  background: rgba(14, 165, 233, 0.13);\n  border: 1px solid rgba(96, 165, 250, 0.35);\n  color: #bfdbfe;\n  animation: stm-xp-rise 1.35s ease both;\n}\n\n.stm-xp-floater__amount {\n  font-size: 1rem;\n  font-weight: 850;\n}\n\n.stm-xp-floater__tags {\n  max-width: 132px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #93c5fd;\n  font-size: 0.68rem;\n}\n\n.stm-keystone-marker {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 160px;\n  padding: 10px 12px;\n  border: 1px solid var(--stm-keystone-accent);\n  border-radius: 8px;\n  background: rgba(15, 23, 42, 0.82);\n}\n\n.stm-keystone-marker__ring {\n  height: 7px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.18);\n}\n\n.stm-keystone-marker__ring span {\n  display: block;\n  width: 100%;\n  height: 100%;\n  transform-origin: left center;\n  background: var(--stm-keystone-accent);\n  border-radius: inherit;\n}\n\n.stm-keystone-marker__copy {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  color: #e2e8f0;\n  font-size: 0.78rem;\n}\n\n.stm-keystone-marker__copy strong {\n  color: var(--stm-keystone-accent);\n  font-size: 0.8rem;\n}\n\n@keyframes stm-card-pop {\n  from { opacity: 0; transform: translateY(6px) scale(0.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes stm-shine {\n  0% { left: -42%; }\n  52%, 100% { left: 118%; }\n}\n\n@keyframes stm-node-pulse {\n  0% { opacity: 0.7; transform: scale(0.92); }\n  72%, 100% { opacity: 0; transform: scale(1.34); }\n}\n\n@keyframes stm-xp-rise {\n  0% { opacity: 0; transform: translateY(8px) scale(0.94); }\n  18% { opacity: 1; transform: translateY(0) scale(1.04); }\n  100% { opacity: 0; transform: translateY(-42px) scale(0.96); }\n}\n\n@media (max-width: 820px) {\n  .stm-content {\n    grid-template-columns: 1fr;\n  }\n\n  .stm-detail {\n    border-left: 0;\n    border-top: 1px solid rgba(148, 163, 184, 0.18);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .stm-card-unlock,\n  .stm-card-unlock__shine,\n  .stm-node__pulse,\n  .stm-xp-floater {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
